import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from './PrinciNavbar';
import { baseurl } from '../../url';
import './Hodassign.css'; // Import CSS file for styling

const TeacherList = () => {
  const [teachers, setTeachers] = useState([]);
  const [hods, setHods] = useState([]);
  const [assignedTeacher, setAssignedTeacher] = useState(null);
  const [selectedTeacherId, setSelectedTeacherId] = useState(null);
  const [showAddHodForm, setShowAddHodForm] = useState(false);
  const [newHod, setNewHod] = useState({
    teachername: '',
    email: '',
    branches: '',
    semesters: '',
    subjects: '',
    subjectCode: '',
    department: '',
  });

  useEffect(() => {
    fetchTeachers();
    fetchHODs();
  }, []);

  const fetchTeachers = () => {
    axios.get(`${baseurl}/api/hod/teachers`)
      .then(response => {
        setTeachers(response.data);
      })
      .catch(error => {
        console.error('Error fetching teachers:', error);
      });
  };

  const fetchHODs = () => {
    axios.get(`${baseurl}/api/hod/hods`)
      .then(response => {
        setHods(response.data);
      })
      .catch(error => {
        console.error('Error fetching HODs:', error);
      });
  };

  const assignHOD = (teacherId) => {
    const selectedTeacher = teachers.find(teacher => teacher._id === teacherId);
    if (!selectedTeacher) return;

    axios.post(`${baseurl}/api/hod/assign`, { teacherId, department: selectedTeacher.department })
      .then(response => {
        console.log('HOD assigned successfully:', response.data);
        setAssignedTeacher(response.data.teachername);
        setSelectedTeacherId(null);
        fetchTeachers();
        fetchHODs();
      })
      .catch(error => {
        console.error('Error assigning HOD:', error);
      });
  };

  const deassignHOD = (hodId) => {
    axios.post(`${baseurl}/api/hod/deassign`, { hodId })
      .then(response => {
        console.log('HOD de-assigned successfully:', response.data);
        setAssignedTeacher(null);
        fetchTeachers();
        fetchHODs();
      })
      .catch(error => {
        console.error('Error de-assigning HOD:', error);
      });
  };

  const handleAddHodChange = (e) => {
    const { name, value } = e.target;
    setNewHod((prevNewHod) => ({ ...prevNewHod, [name]: value }));
  };

  const handleAddHodSubmit = (e) => {
    e.preventDefault();
    axios.post(`${baseurl}/api/admin/addTeacher`, newHod)
      .then(response => {
        setShowAddHodForm(false);
        setNewHod({
          teachername: '',
          email: '',
          branches: '',
          semesters: '',
          subjects: '',
          subjectCode: '',
          department: '',
        });
        fetchTeachers();
        fetchHODs();
      })
      .catch(error => {
        console.error('Error adding HOD:', error);
      });
  };

  return (
    <div>
      <Navbar />
      <div className="teacher-page-container">
        {/* HOD List */}
        <div className="hod-list-container">
          <h3>List of HODs</h3>
          <table>
            <thead>
              <tr>
                <th>Serial No</th>
                <th>Name</th>
                <th>Department</th>
                <th>Email</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {hods.map((hod, index) => (
                <tr key={hod._id}>
                  <td>{index + 1}</td>
                  <td>{hod.teachername}</td>
                  <td>{hod.department}</td>
                  <td>{hod.email}</td>
                  <td>
                    <button className="deassign-button" onClick={() => deassignHOD(hod._id)}>De-Assign</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
        </div>
               
        {selectedTeacherId && (
          <div>
            <h3>Assign HOD</h3>
            <p>Selected Teacher: {teachers.find(teacher => teacher._id === selectedTeacherId)?.teachername}</p>
            <button className="assign-button" onClick={() => assignHOD(selectedTeacherId)}>Confirm Assign as HOD</button>
            <button className="cancel-button" onClick={() => setSelectedTeacherId(null)}>Cancel</button>
          </div>
        )}

               {/* Teacher List */}
        <div className="teacher-list-container">
          <h3>List of Teachers</h3>
          <table>
            <thead>
              <tr>
                <th>Serial No</th>
                <th>Name</th>
                <th>Department</th>
                <th>Email</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {teachers.map((teacher, index) => (
                <tr key={teacher._id}>
                  <td>{index + 1}</td>
                  <td>{teacher.teachername}</td>
                  <td>{teacher.department}</td>
                  <td>{teacher.email}</td>
                  <td>
                    <button className="assign-button" onClick={() => setSelectedTeacherId(teacher._id)}>Assign as HOD</button>
                    {assignedTeacher && assignedTeacher === teacher.teachername && (
                      <p className="success-message">{teacher.teachername} has been assigned as HOD successfully!</p>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

       
        {/* Add HOD Form */}
        {showAddHodForm && (
          <div className="add-hod-form">
            <h3>Add New HOD</h3>
            <form onSubmit={handleAddHodSubmit}>
              <input
                type="text"
                name="teachername"
                placeholder="Teacher Name"
                value={newHod.teachername}
                onChange={handleAddHodChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={newHod.email}
                onChange={handleAddHodChange}
                required
              />
              <select
                name="department"
                value={newHod.department}
                onChange={handleAddHodChange}
                required
              >
                <option value="">Select Department</option>
                <option value="CS">CS</option>
                <option value="EC">EC</option>
                <option value="EE">EE</option>
                <option value="Applied Science">Applied Science</option>
              </select>
              <button type="submit">Add HOD</button>
              <button type="button" className="cancel-button" onClick={() => setShowAddHodForm(false)}>Cancel</button>
            </form>
          </div> 
        )}

       
      </div>
       {/* Add HOD Button */}
       <button className="add-hod-button" onClick={() => setShowAddHodForm(true)}>Add New Teacher</button>
    </div>
  );
};

export default TeacherList;
